import React from "react";

const tapContext = React.createContext("$NO-SELECTED");

export default tapContext;